"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.updateCustommeta = exports.changeGategoryName = exports.toggleCategory = exports.updateField = exports.setProject = exports.saveFailed = exports.saveSuccess = exports.saveRequest = exports.stepValidationFailed = exports.stepValidationSuccess = exports.changeStep = void 0;
const ActionTypes = require("../../actionTypes/subproject/wizard");
const changeStep = (step) => ({
    type: ActionTypes.CHANGE_STEP,
    payload: step
});
exports.changeStep = changeStep;
const stepValidationSuccess = (step) => ({
    type: ActionTypes.STEP_VALIDATION_SUCCESS,
    payload: step
});
exports.stepValidationSuccess = stepValidationSuccess;
const stepValidationFailed = (validation) => ({
    type: ActionTypes.STEP_VALIDATION_FAILED,
    payload: validation
});
exports.stepValidationFailed = stepValidationFailed;
const saveRequest = (payload) => ({
    type: ActionTypes.SAVE_REQUEST,
    payload
});
exports.saveRequest = saveRequest;
const saveSuccess = () => ({
    type: ActionTypes.SAVE_SUCCESS
});
exports.saveSuccess = saveSuccess;
const saveFailed = (error) => ({
    type: ActionTypes.SAVE_FAILED,
    payload: error
});
exports.saveFailed = saveFailed;
const setProject = (project) => ({
    type: ActionTypes.SET_PROJECT,
    payload: project
});
exports.setProject = setProject;
const updateField = (key, value) => ({
    type: ActionTypes.UPDATE_FIELD,
    payload: {
        key,
        value
    }
});
exports.updateField = updateField;
const toggleCategory = (groups, selected) => ({
    type: ActionTypes.TOGGLE_CATEGORY,
    payload: { groups, selected }
});
exports.toggleCategory = toggleCategory;
const changeGategoryName = (group, groupName) => ({
    type: ActionTypes.CHANGE_CATEGORY_NAME,
    payload: {
        group,
        groupName
    }
});
exports.changeGategoryName = changeGategoryName;
const updateCustommeta = (identifier, value) => ({
    type: ActionTypes.UPDATE_CUSTOMMETA,
    payload: {
        identifier,
        value
    }
});
exports.updateCustommeta = updateCustommeta;
const clear = () => ({
    type: ActionTypes.CLEAR
});
exports.clear = clear;
//# sourceMappingURL=wizard.js.map